<template>
  <div class="box">
    <div class="container">
      <div class="item line_bottom">
        <div class="left">
          <span>退货单号</span>
          <span>{{orderNumber}}</span>
        </div>
      </div>
      <!-- 收货方式 -->
      <div class="accpet_type line_bottom">
        <span class="type_t">收货方</span>
        <div class="sent_type">
          <span
            v-for="(item,index) in typeList"
            :key="index"
            @click="selectType(item,index)"
            :class="{'active':item.select}"
          >{{item.type}}</span>
        </div>
      </div>
      <div class="item_input line_bottom">
        <div class="left">
          <span class="orderNum">收货人姓名</span>
          <input type="text" class="name" placeholder="请输入收货人姓名" v-model="name" />
        </div>
      </div>
      <div class="item_input line_bottom">
        <div class="left">
          <span class="orderNum">联系方式</span>
          <input type="text" class="name" placeholder="请输入联系方式" v-model="phone" />
        </div>
      </div>
      <!-- 选择省份城市 -->
      <div class="item line_bottom" @click="showType">
        <div class="left">
          <span>州市/区县</span>
          <span class="result_style" :class="{'active_style':isfalse}">{{typeValue}}</span>
        </div>
        <img src="../../../../assets/image/right.png" class="back" />
      </div>
      <!-- <div class="item_input1">
        <span class="orderNum">详细地址:</span>
        <textarea type="text" class="name1" placeholder="请输入详细地址" v-model="address" />
      </div>-->
      <div class="item_input">
        <div class="left">
          <span class="orderNum">详细地址</span>
          <textarea placeholder="请输入详细地址" class="txtarea" v-model="address"></textarea>
        </div>
      </div>
      <div class="btn" v-show="isOriginHei">
        <span @click="confirm" :class="{'active':change}">确定</span>
      </div>
      <common-picker
        ref="commonPicker"
        :typeList="typeList1"
        :cols="cols1"
        @getTypeValue="getCityValue"
      ></common-picker>
    </div>
  </div>
</template>
<script>
import commonPicker from "../../../../components/base/commonPicker";
import util from "../../../../utils/common";
import api from "../../../../service/modules/refund";
import { timeType } from "../../../../utils/configJson";
export default {
  components: {
    commonPicker
  },
  data() {
    return {
      title: "反馈退货地址",
      flowId: this.$router.currentRoute.query.flowId,
      orderNumber: this.$router.currentRoute.query.number,
      typeList: [
        { type: "企业", value: "30", select: false },
        { type: "监理中心", value: "10", select: false }
      ],
      typeValue: "请选择州市/区县",
      isOriginHei: true,
      name: "",
      typeList1: timeType,
      cols1: 2,
      phone: "",
      address: "",
      code: "",
      documentHeight: document.documentElement.clientHeight, // 默认屏幕高度
      isfalse: false,
      city: "",
      county: "",
      regionCode: "", // 所在区域的code
      isFlag: true
    };
  },
  computed: {
    change() {
      if (
        this.code !== "" &&
        this.name.trim().length > 0 &&
        this.phone.trim().length > 0 &&
        this.address.trim().length > 0
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        if (this.documentHeight > document.documentElement.clientHeight) {
          this.isOriginHei = false;
        } else {
          this.isOriginHei = true;
        }
      })();
    };
  },
  created() {
    // this.getType();
    this.regionCode = this.$store.state.refund.userInfo.regionCode;
    this.getAllCity();
  },
  methods: {
    getType() {
      var list = util.getJsonLocal("configList").DELIVERY_OBJECT;
      list.map((item, index) => {
        var obj = { type: item.name, value: item.code, select: false };
        this.typeList.push(obj);
      });
    },
    getCityValue(value) {
      if (value.length === 2) {
        this.city = value[0].value;
        this.county = value[1].value;
        this.typeValue = value[0].label + value[1].label;
      } else {
        this.city = value[0].value;
        this.typeValue = value[0].label;
      }
      this.isfalse = true;
    },
    selectType(item, index) {
      this.typeList.map((item, index) => {
        this.$set(this.typeList[index], "select", false);
      });
      this.$set(this.typeList[index], "select", true);
      this.code = item.value;
      if (this.code == "10") {
        // 调用接口，获取历史地址
        this.getCurrentUserDefaultDeliveryAddress();
      } else {
        this.typeValue = "请选择州市/区县";
        this.isfalse = false;
        this.address = "";
        this.phone = "";
        this.name = "";
      }
    },
    showType() {
      this.$refs.commonPicker.showPicker();
    },

    getAllCity() {
      // 获取所有的市
      api.getCity().then(res => {
        var list = res.data[0];
        let city = [];
        this.cols1 = 2;
        console.log(list);
        list.children.map((item, index) => {
          const obj = { value: item.code, label: item.shortName, children: [] };

          if (item.children) {
            item.children.map((item1, index1) => {
              const obj1 = {
                value: item1.code,
                label: item1.shortName,
                children: []
              };
              obj.children.push(obj1);
            });
          }
          city.push(obj);
        });
        console.log(city);
        this.typeList1 = [];
        this.typeList1.push(city);
        setTimeout(() => {
          this.$refs.commonPicker._initFresh();
        }, 50);
      });
    },
    confirm() {
      if (this.code === "") {
        this.$Toast({
          message: "请选择收货方"
        });
      } else if (this.name.trim().length === 0) {
        this.$Toast({
          message: "请选择收货人姓名"
        });
      } else if (this.phone.trim().length === 0) {
        this.$Toast({
          message: "请选择联系人方式"
        });
      } else if (this.typeValue === "请选择州市/区县") {
        this.$Toast({
          message: "请选择省份城市"
        });
      } else if (this.address.trim().length === 0) {
        this.$Toast({
          message: "请输入详情地址"
        });
      } else {
        if (this.isFlag) {
          // console.log({
          //     flowId: this.flowId,
          //     contactTel: this.phone,
          //     contact: this.name,
          //     deliveryObject: this.code,
          //     address: this.address,
          //     province: '530000',
          //     city: this.city,
          //     county: this.county
          // })
          this.getAddress();
          this.isFlag = false;
        }
      }
    },
    getCurrentUserDefaultDeliveryAddress() {
      // 获取历史地址
      api.currentUserDefaultDeliveryAddress({}).then(res => {
        console.log(res);
        if (res.ret === 0) {
          if (res.data) {
            if (res.data.cityName === res.data.countyName) {
              this.typeValue = res.data.countyName;
            } else {
              this.typeValue = res.data.cityName + res.data.countyName;
            }
            this.address = res.data.address;
            this.isfalse = true;
            this.city = res.data.cityCode;
            this.county = res.data.countyCode;
            this.phone = res.data.tel;
            this.name = res.data.contact;
          }
        } else {
          // 第一次填写地址
        }
      });
    },
    getAddress() {
      // 反馈退货收货地址
      api
        .address({
          flowId: this.flowId,
          contactTel: this.phone,
          contact: this.name,
          deliveryObject: this.code,
          address: this.address,
          province: "530000",
          city: this.city,
          county: this.county
        })
        .then(res => {
          if (res.ret === 0) {
            this.$Toast({
              message: res.msg
            });
            this.isOriginHei = false;
            setTimeout(() => {
              this.$router.back();
            }, 1500);
          }
        });
    }
  }
};
</script>
<style scoped  lang="less">
.box {
  width: 100%;
  .container {
    width: 100%;
    height: 100vh;
    padding: 0px 12px 0 12px;
    .item {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      padding: 24px 0;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        span:nth-child(2) {
          display: inline-block;
          width: 200px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-left: 40px;
        }
        span {
          font-size: 14px;
          color: #333333;
          line-height: 16px;
        }
        .result_style {
          color: #cccccc;
        }
        .active_style {
          color: #000 !important;
        }
      }
      .back {
        width: 6px;
        height: 12px;
      }
    }
    .item_input {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      padding: 14px 0;
      flex-direction: row;
      .left {
        .orderNum {
          display: inline-block;
          font-size: 14px;
          width: 100px;
          color: #4a4a4a;
        }
        .txtarea {
          border: none;
          border-radius: 5px;
          padding-top: 10px;
          padding-left: 10px;
          background-color: #f2f2f2;
          height: 100px;
          width: 340px;
          resize: none;
          font-size: 14px;
          margin-top: 16px;
        }
        .name {
          height: 40px;
          border: 0;
          outline: none;
          font-size: 14px;
        }
        .name1 {
          white-space: wrap;
        }
        .result_style {
          color: #cccccc;
        }
      }
    }
    .item_input1 {
      display: flex;
      display: -webkit-flex;
      padding: 10px 0;
      flex-direction: row;
      margin-top: 20px;
      .orderNum {
        display: inline-block;
        font-size: 14px;
        width: 100px;
        color: #333333;
      }
      .name1 {
        display: inline-block;
        width: 70%;
        height: 80px;
        border: 1px solid #efefef;
        padding: 16px 10px 16px 16px;
        box-sizing: border-box;
        font-size: 14px;
        line-height: 1.3em;
        border-radius: 6px;
      }
    }
    .accpet_type {
      padding: 23px 0;
      .type_t {
        display: inline-block;
        font-size: 14px;
        color: #333333;
      }
      .sent_type {
        margin-top: 12px;
        span {
          display: inline-block;
          width: 92px;
          height: 30px;
          border: 1px solid @base-color;
          border-radius: 1px;
          text-align: center;
          line-height: 30px;
          color: @base-color;
          font-size: 14px;
        }
        span:nth-child(2) {
          margin-left: 16px;
        }
        span:nth-child(3) {
          margin-left: 12px;
        }
        .active {
          background-color: @base-color;
          color: #fff;
        }
      }
    }
    .btn {
      width: 100%;
      height: 50px;
      padding: 0 12px;
      position: absolute;
      left: 0;
      bottom: 12px;
      span {
        width: 100%;
        height: 100%;
        display: inline-block;
        background-color: @base-color;
        opacity: 0.5;
        text-align: center;
        line-height: 50px;
        font-size: 16px;
        color: #fff;
        border-radius: 3px;
      }
      .active {
        opacity: 1;
      }
    }
  }
}
</style>
